<template>
    <v-data-table
        dense
        :headers="headers"
        :items="data"
        :data="loading"
        :loading="loading"
        :server-items-length="length"
        :options="options"
        disable-sort
        @update:options="updateOptions"
        :footer-props="footer"
        >
        <template v-slot:[`item.code`]="{item}">
            <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.payment.read)">
                <v-icon>mdi-magnify</v-icon>
            </v-btn>
            {{item.code}}
        </template>
        <template v-slot:[`item.paid_amount`]="{item}">
            {{formatMoney(item.paid_amount, item.currency)}}
        </template>
        <template v-slot:[`item.state`]="{item}">
            <PStatus :state="item.state"/>
        </template>
    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import PStatus from './../common/PStatus'
import { mapActions, mapGetters } from 'vuex';
import { formatMoney } from 'accounting';

export default {
    name: "PurchasePaymentList",
    components: {
        PStatus
    },
    data() {
        return {
            footer: {
                'items-per-page-options': [10, 25, 50, 100, 150]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Mode", value: "mode" },
                { text: "Supplier", value: "supplier" },
                { text: "Paid Amount", value: "paid_amount" },
                { text: "Created By", value: "created_by" },
                { text: "State", value:"state"},
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            options: "purchase/payment/options",
            loading: "purchase/payment/loading",
            length: "purchase/payment/length",
            data: "purchase/payment/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            updateOptions: "purchase/payment/updateOptions",
            index: "purchase/payment/index"
        }),
        handleClickRow(item) {
            this.$router.push({name: "PurchasePaymentDisplay", params: {id: item.id}})
        },
        formatMoney(amount, symbol) {
            return formatMoney(amount, {
                symbol,
                precision: 2,
                thousand: ",",
                format: {
                    pos : "%s %v",
                    neg : "%s (%v)",
                    zero: "--"
                }
            });
        }
    }
}
</script>

<style>

</style>